import { defineComponent as _defineComponent } from 'vue'
import { useToken } from '@/useToken';
  import { useUser } from '@/useUser';
  import { onMounted, ref, watch } from 'vue';
  import { UserDataSource } from '@/Sources';
  import { AjaxHelper, IPaginatedList } from '@samc/common';
  import { IEntityData } from '@samc/taskmanagement-ui';
  import { IPackageEntity, handleGetEntityName, handleEntityClick } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TasksPage',
  props: {
    verificationToken: { type: String, required: true },
    apiRoot: { type: String, required: true }
  },
  setup(__props: any) {

  

  const { user } = useUser();
  const { token } = useToken();
  const grid = ref<HTMLTmTaskGridElement | null>(null);

  const entityMap = new Map<number, IPackageEntity>();
  const loadedEntities = ref<IEntityData[]>([]);

  const loadEntities = async () => {
    const helper = new AjaxHelper('/datasource/packagesbasic', '', '', null);
    const result = await helper.getData<IPaginatedList<IPackageEntity>>();
    result.items.forEach(entity => {
      if (entity?.id !== null && entity?.id !== undefined) {
        entityMap.set(entity.id, entity);
      }
    });
    loadedEntities.value = result.items;
  };

  onMounted(() => {
    loadEntities();
  });

  const onGetEntityName = (evt: CustomEvent) => handleGetEntityName(entityMap, evt);
  const onEntityClick = (evt: CustomEvent) => handleEntityClick(entityMap, evt);

  watch([grid, user], ([newGrid, newUser]) => {
    if (newGrid === null || newUser === null) return;

    newGrid.userSource = new UserDataSource();
    newGrid.entitySource = loadedEntities.value;
    newGrid.currentUser = newUser;
  });

  watch(loadedEntities, (entities) => {
    if (grid.value !== null) {
      grid.value.entitySource = entities;
    }
  });

return { __sfc: true,user, token, grid, entityMap, loadedEntities, loadEntities, onGetEntityName, onEntityClick }
}

})